"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioCollection = void 0;
var typescript_collections_1 = require("typescript-collections");
var MathUtils = require("../Utils/MathUtils");
var AudioCollection = /** @class */ (function () {
    function AudioCollection() {
        this._tracks = new typescript_collections_1.Dictionary();
        this._volume = 1;
    }
    Object.defineProperty(AudioCollection.prototype, "volume", {
        get: function () {
            return this._volume;
        },
        set: function (pValue) {
            this._volume = MathUtils.clamp(pValue, 0, 1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AudioCollection.prototype, "tracks", {
        get: function () {
            return this._tracks;
        },
        enumerable: false,
        configurable: true
    });
    return AudioCollection;
}());
exports.AudioCollection = AudioCollection;
//# sourceMappingURL=AudioCollection.js.map